import './styles/index.less';
import Register from './Register';

export default Register;
